import 'es6-promise/auto'
import 'babel-polyfill'
import {toast, projectStatusCheck} from './mixin'
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import VueProgressBar from 'vue-progressbar'
import store from './store'
import 'bootstrap/dist/js/bootstrap.js'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'startbootstrap-sb-admin-2/js/sb-admin-2.min.js'
import 'startbootstrap-sb-admin-2/vendor/fontawesome-free/css/all.min.css'
import 'startbootstrap-sb-admin-2/css/sb-admin-2.min.css'
import '@/assets/content_wrapper.css'
import VueAxios from 'vue-axios'
import {ins as axios} from './plugin/axios'
import VeeValidate from 'vee-validate'
import VueTypedJs from 'vue-typed-js'
import Version from './version'
// import VueCookies from 'vue-cookies'
import VueObserveVisibility from 'vue-observe-visibility'
import VueAwesomeCountdown from 'vue-awesome-countdown'
import ICountUp from 'vue-countup-v2'

const SideMenu = () => import('@/components/SideMenu')
const Navbar = () => import('@/components/Navbar')
const Pending = () => import('@/components/Pending')
const Error = () => import('@/components/Error')
const ProjectNavNew = () => import('@/components/projectNavigationNew')
Vue.use(VeeValidate, {fieldsBagName: 'formFields'})
Vue.use(BootstrapVue)
if (store.getters.accessToken) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${store.getters.accessToken}`
  axios.defaults.headers.common['Panel-Hub-Version'] = `${Version}`
}
Vue.use(VueAxios, axios)
Vue.use(VueTypedJs)
// Vue.use(VueCookies)
Vue.use(VueObserveVisibility)
Vue.use(VueAwesomeCountdown, 'vac')
// VUE PROGRESS
const options = {
  color: '#2A4B7C',
  failedColor: '#874b4b',
  thickness: '5px',
  transition: {
    speed: '1.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
}
Vue.use(VueProgressBar, options)
Vue.component('ICountUp', ICountUp)
Vue.component('SideMenu', SideMenu)
Vue.component('Navbar', Navbar)
Vue.component('Pending', Pending)
Vue.component('Error', Error)
Vue.component('ProjectNavNew', ProjectNavNew)
// Vue.component('ValidationProvider', ValidationProvider)
Vue.config.productionTip = false
// MIXIN

Vue.mixin({
  methods: {
    toast,
    projectStatusCheck,
    nf (value) {
      return isNaN(value) ? 0 : new Intl.NumberFormat('ko-KR', {maximumFractionDigits: 1}).format(value)
    },
    async isEditable ({surveyID}) {
      try {
        const {editable} = await this.projectStatusCheck({surveyID})
        return editable
      } catch (e) {
        return false
      }
    },
    async isSurveyOn ({surveyID}) {
      try {
        const {isOn} = await this.projectStatusCheck({surveyID})
        return isOn
      } catch (e) {
        return false
      }
    }
  },
  computed: {
    isAdmin () {
      return (2 ** 16 & (store.getters.user.auth || 2 ** 1)) > 0
    },
    contentWrapper () {
      const {userBackgroundImage} = store.getters
      if (userBackgroundImage && userBackgroundImage.length) {
        const random = userBackgroundImage[Math.floor(Math.random() * userBackgroundImage.length)].url
        // const url = userBackgroundImage.sort(() => Math.random - 0.5).map(image => `url('${image.url}')`)[0]
        return {'--bgImage': `url('${random}')`}
      }
      return {'--bgImage': ''}
    }
  }
})

const vm = new Vue({
  name: 'main',
  router,
  store,
  components: { App },
  data () {
    return {
      pending: false
    }
  },
  sockets: {
    connect () {
      console.warn('socket connected')
    },
    customEmit (data) {
      console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)', data)
    }
  },
  mounted () {
  },
  created () {
    // MARK: 최초 접근
    console.log('created')
    this.firstInit()
  },
  methods: {
    async firstInit () {
      if (!store) return
      try {
        await store.dispatch('requestPermission')
      } catch (e) {
        console.log(e)
      }
      try {
        if (!store.getters.accessToken) return
        if (store.getters.isConnected) await store.dispatch('disconnect')
      } catch (e) {
        console.log(e)
      }
      try {
        await store.dispatch('verify')
      } catch (e) {
        console.log(e)
      }
      try {
        await store.dispatch('socketConn')
      } catch (e) {
        console.log(e)
      }
      try {
        if (!store.getters.firebaseToken) await store.dispatch('firebaseInit', {})
      } catch (e) {
        console.log(e)
      }
    }
  },
  template: '<App/>'
})
vm.$mount('#app')
export default vm



// WEBPACK FOOTER //
// ./src/main.js